import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../assets/img/logo.svg'
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import {useState, useEffect} from 'react'
import { useNavigate} from 'react-router-dom';


export default function Navbar(){

    //ajustar el menu de barra si la pantalla es menor a cierto tamaño
    const [screen, setScreen] = useState(true);

    const [windowSize, setWindowSize] = useState(getWindowSize());

    useEffect(() => {
      function handleWindowResize() {
        setWindowSize(getWindowSize());
      }
  
      window.addEventListener('resize', handleWindowResize);
  
      return () => {
        window.removeEventListener('resize', handleWindowResize);
      };
    }, []);

    useEffect(() => {

      if(windowSize.innerWidth >=650){
          setScreen(true)
      }
      else{
          setScreen(false)
      }
    });

    //navegacion
    const navigate = useNavigate();
    const redirect = () =>{
      navigate("/");
  }
    const redirect1 = () =>{
        navigate("/projects");
    }
    const redirect2 = () =>{
      navigate("/about-me");
    }
    const redirect3 = () =>{
      navigate("/contact");
    }
    



    //Abrir drawer cuando de click en boton del menu
    const [state, setState] = React.useState(false);


    const toggleDrawer = (anchor, open) => (event) => {
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }
  
      setState({ ...state, [anchor]: open });
    };
  
    const list = (anchor,index) => (
      <Box
        sx={{ width: 'auto'}}
        role="presentation"
        onClick={toggleDrawer(anchor, false)}
        onKeyDown={toggleDrawer(anchor, false)}
      >
        <List key={index} sx={{background:'black'}}>
        <ListItem>
                <ListItemText color="dark">
                  <Button color="primary"
                  sx={{"&:hover":{color:'#4dd0e1'},
                  textTransform: "none",
                  fontFamily: 'Questrial',
                  fontSize:17}} 
                  onClick={redirect}>Home</Button>
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                <Button color="primary"
                  sx={{"&:hover":{color:'#4dd0e1'},
                  textTransform: "none",
                  fontFamily: 'Questrial',
                  fontSize:17}} 
                  onClick={redirect1}>Projects</Button>
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                <Button color="primary"
                  sx={{"&:hover":{color:'#4dd0e1'},
                  textTransform: "none",
                  fontFamily: 'Questrial',
                  fontSize:17}} 
                  onClick={redirect2}>About me</Button>
                </ListItemText>
              </ListItem>
              <ListItem >
                <ListItemText>
                <Button color="primary"
                  sx={{"&:hover":{color:'#4dd0e1'},
                  textTransform: "none",
                  fontFamily: 'Questrial',
                  fontSize:17}} 
                  onClick={redirect3}>Contact</Button>
                </ListItemText>
              </ListItem>
        </List>
        <Divider />
      </Box>
    );


    return(
        <Box sx={{ flexGrow: 1 }}>
        <AppBar position="fixed" color="dark">
          <Toolbar>
            <IconButton edge="start" color="inherit" sx={{ p: 0, mr: 2 }}> 
              <Box  component="img" src={logo}  alt="Logo" sx={{ height: 35 }}/>
            </IconButton>

            <Typography variant="h6" component="div"  noWrap sx={{ flexGrow: 1, fontFamily: 'Questrial' }}>
              
            </Typography>
            {screen ?
            <>
            <Button color="primary"
            sx={{"&:hover":{color:'#4dd0e1'},
            textTransform: "none",
            fontFamily: 'Questrial',
            fontSize:17}} 
            onClick={redirect}>Home</Button>

            <Button color="primary"
            sx={{"&:hover":{color:'#4dd0e1'},
            textTransform: "none",
            fontFamily: 'Questrial',
            fontSize:17}} 
            onClick={redirect1}>Projects</Button>

            <Button color="primary"
            sx={{"&:hover":{color:'#4dd0e1'},
            textTransform: "none",
            fontFamily: 'Questrial',
            fontSize:17}} 
            onClick={redirect2}>About me</Button>

            <Button color="primary"
            sx={{"&:hover":{color:'#4dd0e1'},
            textTransform: "none",
            fontFamily: 'Questrial',
            fontSize:17}} 
            onClick={redirect3}>Contact</Button></>
            :
            
            <div>
            {['top'].map((anchor) => (
              <>
                <IconButton color="primary" onClick={toggleDrawer(anchor, true)}>
                <MenuIcon />

                </IconButton>
                <Drawer
                sx={{alignItems:"center",
                justifyContent:"center"}}
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}
                >
                  {list(anchor)}
                </Drawer>
              </>
            ))}
            </div>
            }

          </Toolbar>
        </AppBar>
        <Toolbar />
      </Box>
    )

    function getWindowSize() {
      const {innerWidth, innerHeight} = window;
      return {innerWidth, innerHeight};
    }
}